/* Custom disc photo studio.
   One 9-disc set per customized box ("Box 1", "Box 2", ...).
   Circular drag-to-position crop, default designs as fillers.
   Continue stays locked until every set is complete, then the photos ride
   to checkout as (hidden) line item properties — one $10 add-on line per box. */
(function () {
  'use strict';

  var PLAYER_HANDLE = 'islamifybox-quran-mini-vinyl-player';
  var UPSELL_HANDLE = 'custom-disc-photos';
  var SLOT_COUNT = 9;
  var LS_KEY = 'ib_disc_photos_v2';

  var setsEl = document.getElementById('discSets');
  if (!setsEl) return; /* not the upload page */

  function urlParam(name, fallback) {
    var m = window.location.search.match(new RegExp('[?&]' + name + '=(\\d+)'));
    var n = m ? parseInt(m[1], 10) : NaN;
    return isNaN(n) || n < 1 ? fallback : n;
  }

  var BOXES = urlParam('boxes', 1);              /* total players ordered */
  var SET_COUNT = Math.min(urlParam('custom', 1), BOXES); /* sets to customize */

  var subEl = document.querySelector('.disc-sub');
  var countEl = document.getElementById('discCount');
  var continueBtn = document.getElementById('discContinue');
  var errorEl = document.getElementById('discError');
  var fillBtn = document.getElementById('discFillDefaults');

  var chooser = document.getElementById('discChooser');
  var chooserNum = document.getElementById('chooserNum');
  var chooseUpload = document.getElementById('chooseUpload');
  var chooseDefault = document.getElementById('chooseDefault');
  var chooseRemove = document.getElementById('chooseRemove');
  var chooseCancel = document.getElementById('chooseCancel');

  var defaultsModal = document.getElementById('discDefaults');
  var defaultsGrid = document.getElementById('defaultsGrid');
  var defaultsCancel = document.getElementById('defaultsCancel');

  var cropModal = document.getElementById('discCrop');
  var cropStage = document.getElementById('cropStage');
  var cropImg = document.getElementById('cropImg');
  var cropZoom = document.getElementById('cropZoom');
  var cropUse = document.getElementById('cropUse');
  var cropCancel = document.getElementById('cropCancel');

  var fileInput = document.getElementById('discFile');

  var DEFAULTS = window.IB_DEFAULT_DISCS || [];

  /* sets[si].slots[i] = null | { type: 'upload', dataUrl } | { type: 'default', index } */
  var sets = [];
  for (var s = 0; s < SET_COUNT; s++) {
    sets.push({ slots: new Array(SLOT_COUNT).fill(null) });
  }
  var pendingSet = 0;
  var pendingSlot = 0;
  var defaultUrlCache = {};

  if (SET_COUNT > 1 && subEl) {
    subEl.innerHTML =
      'Add a photo to each of the 9 discs <strong>per box</strong>. Drag your photo inside the circle ' +
      'to position it &mdash; what you see is exactly what gets printed. ' +
      'Short on photos? Fill the rest with one of our designs.';
  }

  /* ---------- persistence ---------- */
  function save() {
    try {
      localStorage.setItem(LS_KEY, JSON.stringify({
        boxes: BOXES,
        custom: SET_COUNT,
        sets: sets.map(function (set) { return set.slots; })
      }));
    } catch (e) { /* quota — non-fatal */ }
  }

  function restore() {
    try {
      var raw = localStorage.getItem(LS_KEY);
      if (!raw) return;
      var data = JSON.parse(raw);
      if (!data || data.boxes !== BOXES || data.custom !== SET_COUNT) return;
      if (!Array.isArray(data.sets) || data.sets.length !== SET_COUNT) return;
      data.sets.forEach(function (arr, si) {
        if (!Array.isArray(arr) || arr.length !== SLOT_COUNT) return;
        sets[si].slots = arr.map(function (sl) {
          if (!sl || typeof sl !== 'object') return null;
          if (sl.type === 'upload' && typeof sl.dataUrl === 'string') return sl;
          if (sl.type === 'default' && typeof sl.index === 'number') return sl;
          return null;
        });
      });
    } catch (e) { /* corrupted — start fresh */ }
  }

  /* ---------- helpers ---------- */
  function getJSON(url) {
    return fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('request failed: ' + url);
      return r.json();
    });
  }

  function postJSON(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: data == null ? null : JSON.stringify(data)
    }).then(function (r) {
      if (!r.ok) throw new Error('request failed: ' + url);
      return r.json();
    });
  }

  function loadImage(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.onload = function () { resolve(img); };
      img.onerror = reject;
      img.src = src;
    });
  }

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }

  function hideError() {
    errorEl.hidden = true;
  }

  /* ---------- rendering ---------- */
  function totalSlots() { return SLOT_COUNT * sets.length; }

  function filledCount() {
    var n = 0;
    sets.forEach(function (set) {
      set.slots.forEach(function (sl) { if (sl) n++; });
    });
    return n;
  }

  function render() {
    setsEl.innerHTML = '';
    sets.forEach(function (set, si) {
      var section = document.createElement('section');
      section.className = 'disc-set';
      if (sets.length > 1) {
        var title = document.createElement('h2');
        title.className = 'disc-set-title';
        title.textContent = 'Box ' + (si + 1);
        section.appendChild(title);
      }
      var grid = document.createElement('div');
      grid.className = 'disc-grid';
      set.slots.forEach(function (slot, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'disc-slot' + (slot ? ' is-filled' : '');
        var where = sets.length > 1 ? 'Box ' + (si + 1) + ', disc ' + (i + 1) : 'Disc ' + (i + 1);
        btn.setAttribute('aria-label', where + (slot ? ' — change photo' : ' — add photo'));

        var circle = document.createElement('span');
        circle.className = 'disc-slot-circle';
        if (slot) {
          var img = document.createElement('img');
          img.alt = '';
          img.src = slot.type === 'upload' ? slot.dataUrl : DEFAULTS[slot.index];
          circle.appendChild(img);
        } else {
          var plus = document.createElement('span');
          plus.className = 'disc-plus';
          plus.textContent = '+';
          circle.appendChild(plus);
        }

        var label = document.createElement('span');
        label.className = 'disc-slot-label';
        label.textContent = 'Disc ' + (i + 1);

        btn.appendChild(circle);
        btn.appendChild(label);
        (function (s2, i2) {
          btn.addEventListener('click', function () { openChooser(s2, i2); });
        })(si, i);
        grid.appendChild(btn);
      });
      section.appendChild(grid);
      setsEl.appendChild(section);
    });

    var n = filledCount();
    var total = totalSlots();
    countEl.textContent = n + ' of ' + total + ' discs ready';
    continueBtn.disabled = n < total;
    continueBtn.textContent = n < total ? 'Continue (' + n + '/' + total + ')' : 'Continue to checkout';
  }

  /* ---------- chooser ---------- */
  function openChooser(si, i) {
    pendingSet = si;
    pendingSlot = i;
    chooserNum.textContent = sets.length > 1
      ? 'Box ' + (si + 1) + ' · Disc ' + (i + 1)
      : 'Disc ' + (i + 1);
    chooseRemove.hidden = !sets[si].slots[i];
    chooser.hidden = false;
  }

  function closeChooser() { chooser.hidden = true; }

  chooseUpload.addEventListener('click', function () {
    closeChooser();
    closeDefaults();
    fileInput.value = '';
    fileInput.click();
  });

  chooseDefault.addEventListener('click', function () {
    closeChooser();
    renderDefaults();
    defaultsModal.hidden = false;
  });

  chooseRemove.addEventListener('click', function () {
    sets[pendingSet].slots[pendingSlot] = null;
    save();
    render();
    closeChooser();
  });

  chooseCancel.addEventListener('click', closeChooser);

  /* ---------- defaults ---------- */
  function renderDefaults() {
    defaultsGrid.innerHTML = '';
    DEFAULTS.forEach(function (url, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'defaults-thumb';
      b.setAttribute('aria-label', 'Default design ' + (i + 1));
      var img = document.createElement('img');
      img.alt = '';
      img.loading = 'lazy';
      img.src = url;
      b.appendChild(img);
      b.addEventListener('click', function () {
        sets[pendingSet].slots[pendingSlot] = { type: 'default', index: i };
        save();
        render();
        closeDefaults();
      });
      defaultsGrid.appendChild(b);
    });
  }

  function closeDefaults() { defaultsModal.hidden = true; }
  defaultsCancel.addEventListener('click', closeDefaults);

  fillBtn.addEventListener('click', function () {
    sets.forEach(function (set) {
      set.slots = set.slots.map(function (sl, i) {
        if (sl) return sl;
        return { type: 'default', index: i % Math.max(DEFAULTS.length, 1) };
      });
    });
    save();
    render();
  });

  /* ---------- crop ---------- */
  var crop = { set: 0, slot: 0, objectUrl: null, baseScale: 1, scale: 1, tx: 0, ty: 0, nw: 0, nh: 0, pid: null, sx: 0, sy: 0 };

  function stageSize() { return cropStage.clientWidth; }
  function imgW() { return crop.nw * crop.baseScale * crop.scale; }
  function imgH() { return crop.nh * crop.baseScale * crop.scale; }

  function applyCrop() {
    cropImg.style.width = imgW() + 'px';
    cropImg.style.height = imgH() + 'px';
    cropImg.style.transform = 'translate(' + crop.tx + 'px,' + crop.ty + 'px)';
  }

  /* Keep the image covering the circle: an axis locks when the image exactly
     fits it, and drags freely (until an edge hits the boundary) when larger. */
  function clampCrop() {
    var S = stageSize();
    var w = imgW();
    var h = imgH();
    if (w <= S + 0.5) crop.tx = (S - w) / 2;
    else crop.tx = Math.min(0, Math.max(S - w, crop.tx));
    if (h <= S + 0.5) crop.ty = (S - h) / 2;
    else crop.ty = Math.min(0, Math.max(S - h, crop.ty));
  }

  /* Zoom around the center of the circle so the photo doesn't jump. */
  function setScale(newScale) {
    newScale = Math.max(1, Math.min(3, newScale || 1));
    if (newScale === crop.scale) { clampCrop(); applyCrop(); return; }
    var S = stageSize();
    var ux = (S / 2 - crop.tx) / imgW();
    var uy = (S / 2 - crop.ty) / imgH();
    crop.scale = newScale;
    crop.tx = S / 2 - ux * imgW();
    crop.ty = S / 2 - uy * imgH();
    clampCrop();
    applyCrop();
  }

  function openCrop(objectUrl, setIndex, slotIndex) {
    crop.set = setIndex;
    crop.slot = slotIndex;
    crop.objectUrl = objectUrl;
    crop.scale = 1;
    crop.pid = null;
    cropZoom.value = '1';
    cropModal.hidden = false;
    cropImg.onload = function () {
      var S = stageSize();
      crop.nw = cropImg.naturalWidth;
      crop.nh = cropImg.naturalHeight;
      crop.baseScale = Math.max(S / crop.nw, S / crop.nh);
      crop.tx = (S - crop.nw * crop.baseScale) / 2;
      crop.ty = (S - crop.nh * crop.baseScale) / 2;
      clampCrop();
      applyCrop();
    };
    cropImg.src = objectUrl;
  }

  function closeCrop() {
    cropModal.hidden = true;
    if (crop.objectUrl) {
      URL.revokeObjectURL(crop.objectUrl);
      crop.objectUrl = null;
    }
  }

  /* One finger drags; two fingers pinch to zoom. Slider keeps working too. */
  var activePtrs = new Map(); /* pointerId -> {x, y} */
  var pinchBase = null;       /* {dist, scale} captured when 2nd finger lands */

  function ptrDist() {
    var p = Array.from(activePtrs.values());
    return Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
  }

  cropStage.addEventListener('pointerdown', function (e) {
    activePtrs.set(e.pointerId, { x: e.clientX, y: e.clientY });
    try { cropStage.setPointerCapture(e.pointerId); } catch (err) {}
    if (e.cancelable) e.preventDefault();
    if (activePtrs.size === 2) {
      pinchBase = { dist: ptrDist(), scale: crop.scale };
      crop.pid = null; /* pause drag while pinching */
    } else if (activePtrs.size === 1) {
      crop.pid = e.pointerId;
      crop.sx = e.clientX - crop.tx;
      crop.sy = e.clientY - crop.ty;
    }
  });

  cropStage.addEventListener('pointermove', function (e) {
    if (!activePtrs.has(e.pointerId)) return;
    activePtrs.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (pinchBase && activePtrs.size >= 2) {
      var d = ptrDist();
      if (d > 0 && pinchBase.dist > 0) {
        var ns = Math.max(1, Math.min(3, pinchBase.scale * d / pinchBase.dist));
        if (ns !== crop.scale) {
          setScale(ns);
          cropZoom.value = String(crop.scale); /* keep slider in sync */
        }
      }
      return;
    }
    if (e.pointerId !== crop.pid) return;
    crop.tx = e.clientX - crop.sx;
    crop.ty = e.clientY - crop.sy;
    clampCrop();
    applyCrop();
  });

  function endPtr(e) {
    activePtrs.delete(e.pointerId);
    if (activePtrs.size < 2) pinchBase = null;
    if (e.pointerId === crop.pid) crop.pid = null;
    if (activePtrs.size === 1) {
      /* one finger left after a pinch: resume dragging with it */
      var id = Array.from(activePtrs.keys())[0];
      var p = activePtrs.get(id);
      crop.pid = id;
      crop.sx = p.x - crop.tx;
      crop.sy = p.y - crop.ty;
    }
  }

  ['pointerup', 'pointercancel'].forEach(function (ev) {
    cropStage.addEventListener(ev, endPtr);
  });

  cropZoom.addEventListener('input', function () {
    setScale(parseFloat(cropZoom.value));
  });

  cropCancel.addEventListener('click', closeCrop);

  cropUse.addEventListener('click', function () {
    var S = stageSize();
    var size = 700;
    var k = size / S;
    var canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(
      cropImg,
      crop.tx * k,
      crop.ty * k,
      crop.nw * crop.baseScale * crop.scale * k,
      crop.nh * crop.baseScale * crop.scale * k
    );
    sets[crop.set].slots[crop.slot] = { type: 'upload', dataUrl: canvas.toDataURL('image/jpeg', 0.82) };
    save();
    render();
    closeCrop();
  });

  fileInput.addEventListener('change', function () {
    var f = fileInput.files && fileInput.files[0];
    if (!f) return;
    openCrop(URL.createObjectURL(f), pendingSet, pendingSlot);
  });

  /* ---------- resolve slot images to data URLs ---------- */
  function defaultToDataUrl(index, size, quality) {
    var cacheKey = index + '_' + size;
    if (defaultUrlCache[cacheKey]) return Promise.resolve(defaultUrlCache[cacheKey]);
    return fetch(DEFAULTS[index])
      .then(function (r) {
        if (!r.ok) throw new Error('default fetch failed');
        return r.blob();
      })
      .then(function (blob) { return loadImage(URL.createObjectURL(blob)); })
      .then(function (img) {
        var canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        var s = Math.max(size / img.naturalWidth, size / img.naturalHeight);
        var w = img.naturalWidth * s;
        var h = img.naturalHeight * s;
        ctx.drawImage(img, (size - w) / 2, (size - h) / 2, w, h);
        var url = canvas.toDataURL('image/jpeg', quality);
        defaultUrlCache[cacheKey] = url;
        return url;
      });
  }

  function resolveAllSets(size, quality) {
    var flat = [];
    sets.forEach(function (set) {
      set.slots.forEach(function (slot) {
        if (slot.type === 'upload') flat.push(Promise.resolve(slot.dataUrl));
        else flat.push(defaultToDataUrl(slot.index, size, quality));
      });
    });
    return Promise.all(flat).then(function (urls) {
      var out = [];
      for (var s = 0; s < sets.length; s++) out.push(urls.slice(s * SLOT_COUNT, s * SLOT_COUNT + SLOT_COUNT));
      return out;
    });
  }

  /* ---------- continue to checkout ---------- */
  function buildCart(setsUrls) {
    return getJSON('/products/' + PLAYER_HANDLE + '.js').then(function (p) {
      var playerId = p.variants[0].id;
      return getJSON('/products/' + UPSELL_HANDLE + '.js').then(function (a) {
        var addonId = a.variants[0].id;
        return postJSON('/cart/clear.js', null).then(function () {
          var items = [{ id: playerId, quantity: BOXES }];
          setsUrls.forEach(function (urls, si) {
            var props = {};
            if (setsUrls.length > 1) props['Box'] = String(si + 1);
            urls.forEach(function (u, i) { props['_disc_photo_' + (i + 1)] = u; });
            items.push({ id: addonId, quantity: 1, properties: props });
          });
          return postJSON('/cart/add.js', { items: items });
        });
      });
    });
  }

  function setBusy(busy) {
    continueBtn.disabled = busy || filledCount() < totalSlots();
    if (busy) continueBtn.textContent = 'Preparing your discs…';
    else render();
  }

  continueBtn.addEventListener('click', function () {
    if (filledCount() < totalSlots()) return;
    hideError();
    setBusy(true);
    function attempt(size, quality, retriesLeft) {
      return resolveAllSets(size, quality)
        .then(buildCart)
        .catch(function () {
          if (retriesLeft > 0) return attempt(500, 0.72, retriesLeft - 1);
          throw new Error('failed');
        });
    }
    attempt(700, 0.82, 1).then(
      function () { window.location.href = '/checkout'; },
      function () {
        showError('Could not attach your photos. Please check your connection and try again.');
        setBusy(false);
      }
    );
  });

  /* ---------- init ---------- */
  restore();
  render();

  /* Exposed for automated testing. */
  window.DiscUpload = {
    setSlot: function (si, i, dataUrl) {
      if (typeof dataUrl === 'undefined') { dataUrl = i; i = si; si = 0; }
      sets[si].slots[i] = { type: 'upload', dataUrl: dataUrl };
      save();
      render();
    },
    filled: filledCount,
    total: totalSlots,
    continueEnabled: function () { return !continueBtn.disabled; }
  };
})();
